import React from 'react';
import { Typography } from '@mui/material';
import { HttpMethod, getHttpMethodColor } from '../utils/httpMethodColors';

interface HttpMethodBadgeProps {
    method: HttpMethod;
}

const HttpMethodBadge: React.FC<HttpMethodBadgeProps> = ({ method }) => {
    return (
        <Typography 
            variant="body2"
            fontSize={12}
            fontWeight={700}
            sx={{
                color: getHttpMethodColor(method),
                display: 'inline-block'
            }}
        >
            {method}
        </Typography>
    );
};

export default HttpMethodBadge;
